// extracted by mini-css-extract-plugin
export default {"campusInfo":"ProgramSelect_campusInfo__cxqKc","labelWrapper":"ProgramSelect_labelWrapper__i4Up+","name":"ProgramSelect_name__iHVMe","noCampuses":"ProgramSelect_noCampuses__rg44C"};